import React, { useState } from "react";
import HeroSliderImgs from "../../variables/HeroSliderImgs";
import VideoBackground from "../components/VideoBackground";
import Typography from "../../Typography";
import HeroSliderText from "../../variables/content/HeroSliderText";

const HeroType1 = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index) => {
    setActiveIndex(index);
  };

  const images = HeroSliderImgs;
  const video = "./videos/hero-video.mp4";

  const slideData = HeroSliderText;

  return (
    <div
      id="indicators-carousel"
      className="relative w-full"
      data-carousel="static"
    >
      <div className="absolute left-0 right-0 bottom-0 background black-gradient h-[90px] z-10"></div>
      {/* Carousel wrapper */}
      <div className="max-md:h-[calc(100vh-100px)] max-md:min-h-[650px] relative overflow-hidden h-[100vh] min-h-[700px] max-h-[1200px]">
        {images.map((src, index) => (
          <div
            key={index}
            className={`absolute w-full h-full transition-opacity duration-700 ease-in-out ${
              activeIndex === index
                ? "opacity-100 [transition:all_ease_1.2s]"
                : "opacity-0 [transition:all_ease_0.7s]"
            }`}
            data-carousel-item={activeIndex === index ? "active" : undefined}
          >
            {index === 0 ? (
              <>
                <VideoBackground video={video} />
                <div className="z-2 absolute left-[0] top-[0] bottom-[0] right-[0] bg-[#000] opacity-50"></div>
              </>
            ) : (
              <img
                src={src}
                className={`block w-full h-[100%] md:h-[120%] object-cover ${
                  activeIndex === index
                    ? "md:object-[-200px_-120px] md:scale-[1.2] [transition:all_ease_3s] ease-in-out"
                    : "md:object-[0] md:scale-[1] [transition:all_ease_0.7s] ease-in-out"
                }`}
                alt={`Slide ${index + 1}`}
              />
            )}
            <div className="z-10  pt-[50px] absolute left-0 right-0 top-0 h-full flex flex-col justify-center wrapper">
              {slideData[index]?.title && (
                <Typography.T
                  className={`max-md:text-center max-w-[770px] text-white ${
                    activeIndex === index
                      ? "opacity-100 translate-y-[0] [transition:all_0.8s_ease-in-out] ease-in-out [transition-delay:1s]"
                      : "opacity-0 translate-y-[80px] [transition:all_0.2s_ease-in-out] ease-in-out  [transition-delay:1s]"
                  }`}
                >
                  {slideData[index]?.title}
                </Typography.T>
              )}

              {slideData[index]?.text && (
                <Typography.P
                  className={`max-md:text-center max-xsm:mt-[20px] text-white max-w-[770px] mt-[30px] ${
                    activeIndex === index
                      ? "opacity-100 translate-y-[0] [transition:all_0.8s_ease-in-out] ease-in-out [transition-delay:1s]"
                      : "opacity-0 translate-y-[80px] [transition:all_0.2s_ease-in-out] ease-in-out  [transition-delay:1s]"
                  }`}
                >
                  {slideData[index]?.text}
                </Typography.P>
              )}

              {slideData[index]?.button && (
                <div
                  className={`max-md:flex max-md:justify-center max-xsm:mt-[25px] max-md:mt-[35px] mt-[50px] ${
                    activeIndex === index
                      ? "opacity-100 translate-y-[0] [transition:all_0.8s_ease-in-out] ease-in-out [transition-delay:1s]"
                      : "opacity-0 translate-y-[80px] [transition:all_0.2s_ease-in-out] ease-in-out  [transition-delay:1s]"
                  }`}
                >
                  {slideData[index]?.button}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Slider indicators */}
      <div className="absolute z-30 flex -translate-x-1/2 space-x-3 rtl:space-x-reverse bottom-9 left-1/2">
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`h-[4px] rounded-full [transition:all_ease_0.5s] ${
              activeIndex === index ? "bg-white w-7" : "bg-white w-3 opacity-60"
            }`}
            aria-current={activeIndex === index}
            aria-label={`Slide ${index + 1}`}
            onClick={() => goToSlide(index)}
          ></button>
        ))}
      </div>

      {/* Slider controls */}
      <button
        type="button"
        className="max-lg:pb-[15px] max-lg:items-end max-2xl:left-0 absolute top-0 left-5 z-30 flex items-center justify-center h-full px-4 Typography.Smp group focus:outline-none"
        onClick={handlePrev}
        data-carousel-prev
      >
        <span className="border-[1px] border-[solid] border-white/50 [transition:all_ease_0.5s] inline-flex items-center justify-center w-[50px] h-[50px] rounded-full bg-white/10 group-hover:bg-white/20 group-focus:outline-none">
          <svg
            className="w-4 h-4 text-white rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M5 1 1 5l4 4"
            />
          </svg>
          <span className="sr-only">Previous</span>
        </span>
      </button>

      <button
        type="button"
        className="max-lg:pb-[15px] max-lg:items-end max-2xl:right-0 absolute top-0 right-5 z-30 flex items-center justify-center h-full px-4 Typography.Smp group focus:outline-none"
        onClick={handleNext}
        data-carousel-next
      >
        <span className="border-[1px] border-[solid] border-white/50 [transition:all_ease_0.5s] inline-flex items-center justify-center w-[50px] h-[50px] rounded-full bg-white/10 group-hover:bg-white/20 group-focus:outline-none">
          <svg
            className="w-4 h-4 text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 4 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="m1 9 4-4-4-4"
            />
          </svg>
          <span className="sr-only">Next</span>
        </span>
      </button>
    </div>
  );
};

export default HeroType1;
